document.addEventListener("DOMContentLoaded", function() {
    const readMoreButtons = document.querySelectorAll(".js-read-more");

    readMoreButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const customerItem = btn.closest(".customer-item");
            const textContainer = customerItem.querySelector(".js-customer-text");

            document.querySelectorAll(".customer-text.active").forEach((openText) => {
                if (openText !== textContainer) {
                    openText.classList.remove("active");
                    const openBtn = openText.closest(".customer-item").querySelector(".js-read-more");
                    if (openBtn) openBtn.textContent = "Read more";
                }
            });

            if (textContainer) {
                const isActive = textContainer.classList.contains("active");
                textContainer.classList.toggle("active");
                btn.textContent = !isActive ? "Read less" : "Read more";

                setTimeout(() => {
                    const offset = 100;
                    const top = customerItem.getBoundingClientRect().top + window.pageYOffset - offset;

                    window.scrollTo({
                        top,
                        behavior: "smooth"
                    });
                }, 300);
            }
        });
    });
});